import { Component, input } from '@angular/core';

/**
 * A display heading: Archivo, capitals, tight leading. `size` maps to the display scale;
 * `md` steps down to `sm` on small screens. Colour is inherited.
 */
@Component({
  selector: 'h1[ppcHeading], h2[ppcHeading], h3[ppcHeading], div[ppcHeading]',
  template: '<ng-content />',
  styleUrl: './heading.css',
  host: {
    '[attr.data-size]': 'size()',
  },
})
export class PpcHeading {

  readonly size = input<'sm' | 'md' | 'lg'>('md');

}
